<template>
    <div class="list-product-card">
        <div class="list-product-card-inner">
            <div class="product-card-left">
                <a :href="productUrl" class="product-image">
                     <img :src="baseImage" :class="{ 'image-placeholder': ! hasBaseImage }" alt="product image" class="product-image-1">
                    <img :src="addtionalImage" alt="product image" class="product-image-2 position-absolute">

                    <ul class="list-inline product-badge">
                        <li class="badge badge-danger" v-if="product.is_out_of_stock">
                            {{ $trans('nya::product_card.out_of_stock') }}
                        </li>

                        <li class="badge badge-primary" v-else-if="product.is_new">
                            {{ $trans('nya::product_card.new') }}
                        </li>

                        <li class="badge badge-success" v-if="product.has_percentage_special_price">
                            -{{ product.special_price_percent }}%
                        </li>

                        <li class="badge badge-success" v-if="hasComboPrice" v-for="comboPrice of comboPrices">
                            <span v-text="comboPrice.combo_price"></span>
                        </li>
                    </ul>
                </a>
            </div>

            <div class="product-card-right">
                <a :href="productUrl" class="product-name">
                    <h6>{{ product.name }}</h6>
                    <h6 class="text-secondary"><i>{{ product.latin }}</i></h6>
                </a>

                <div class="clearfix"></div>

                <ProductRating :ratingPercent="product.rating_percent" :reviewCount="product.reviews.length"/>

                <div class="product-price" v-html="product.formatted_price"></div>
                <p v-html="product.short_description"></p>
                <a
                    v-if="product.is_only_sold_store"
                    :href="productUrl"
                    class="btn btn-primary btn-add-to-cart"
                >
                    <i class="fa fa-home"></i>
                    {{ $trans('nya::product_card.is_only_sold_store') }}
                </a>

                <a
                    v-else-if="product.is_out_of_stock"
                    :href="productUrl"
                    class="btn btn-primary btn-add-to-cart"
                >
                    <i class="fa fa-ban"></i>
                    {{ $trans('nya::product_card.out_of_stock') }}
                </a>

                <button
                    v-else-if="!product.is_only_sold_store && hasNoOption"
                    class="btn btn-primary btn-add-to-cart"
                    :class="{ 'btn-loading': addingToCart }"
                    @click="addToCart" style="display: block"
                >
                    <i class="fa fa-shopping-cart"></i>
                    {{ $trans('nya::product_card.add_to_cart') }}
                </button>

                <a
                    v-else
                    :href="productUrl"
                    class="btn btn-primary btn-add-to-cart"
                >
                    <i class="las la-eye"></i>
                    {{ $trans('nya::product_card.view_options') }}
                </a>

                <div class="product-card-actions">
                    <button
                        class="btn btn-wishlist"
                        :class="{ 'added': inWishlist }"
                        @click="syncWishlist"
                    >
                       <i class="fa " :class="inWishlist ? 'fa-heart' : 'fa-heart-o'"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ProductRating from './../../ProductRating.vue';
    import ProductCardMixin from '../../../mixins/ProductCardMixin';

    export default {
        components: { ProductRating },

        mixins: [
            ProductCardMixin,
        ],

        props: ['product'],
    };
</script>
